import React from 'react'
import {fromJS} from 'immutable'
import {connect} from 'react-redux'

import {
  SESSION_TYPES
} from './config/constants'

import showModal from './data/actions/show_modal'

class ContinueCheckoutSessionButton extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.showModal = this.showModal.bind(this)
  }

  showModal (e) {
    if (e && e.preventDefault) e.preventDefault()

    const requestData = fromJS({
      sessionLength: this.props.session.get('sessionLength'),
      type: this.props.session.get('type') === SESSION_TYPES.BOOKED ? 'later' : 'immediate'
    })

    this.props.showSessionInitiateModal({
      type: 'sessionInitiate',
      props: {expert: this.props.expert, bookData: {sessionId: this.props.sessionId, requestData}}
    })
  }

  render () {
    return (
      <a href='#' className={this.props.classNames} onClick={this.showModal}>Continue checkout</a>
    )
  }
}

ContinueCheckoutSessionButton.defaultProps = {
  classNames: 'button success'
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSessionInitiateModal: (modal) => dispatch(showModal(modal))
  }
}

const ContinueCheckoutSessionButtonContainer = connect(
  null, mapDispatchToProps
)(ContinueCheckoutSessionButton)

export default ContinueCheckoutSessionButtonContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/continue_checkout_session_button.js
 **/